module.exports = __webpack_public_path__ + "static/media/ies.af8256d2.png";